var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDivitMilesLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.568,
    height: 17.568,
    viewBox: "0 0 17.568 17.568",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25862",
    "data-name": "Group 25862",
    transform: "translate(-600.079 -472.079)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37379",
    "data-name": "Path 37379",
    d: "M608.863,472.079a8.784,8.784,0,1,0,8.784,8.784A8.784,8.784,0,0,0,608.863,472.079ZM604.58,484.53v-2.564h2.929v1.063l3.753-2.167-3.753-2.167v1.063H604.58V477.2l3.094-1.786,6.352,3.667v3.572l-6.352,3.667Z",
    transform: "translate(0 0)",
    fill: "#009"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivitMilesLogo);
export default __webpack_public_path__ + "static/media/divit-miles-logo.d87db1c61aacf26b8f08d0287977a426.svg";
export { ForwardRef as ReactComponent };